import Switch from '@mui/material/Switch';
import TypographyComponent from '../TypographyComponent';
import { OverridableStringUnion } from '@mui/types';
import { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography/Typography';

interface SwitchComponentProps {
  label?: string;
  variant?: OverridableStringUnion<
    Variant | 'inherit',
    TypographyPropsVariantOverrides
  >;
  value: boolean;
  color?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error'
    | 'default';
  disabled?: boolean;
  onChange?: (val: boolean) => void;
}

const SwitchComponent = ({
  label,
  variant,
  value,
  onChange,
  color,
  disabled = false,
  ...props
}: SwitchComponentProps) => {
  return (
    <>
      <TypographyComponent variant={variant ?? 'h6'}>
        {label}
      </TypographyComponent>
      <Switch
        {...props}
        disabled={disabled}
        color={color}
        onChange={(e) => onChange && onChange(e.target.checked)}
        checked={value}
      />
    </>
  );
};

export default SwitchComponent;
